export class WebPlayerLogger {
  private debug = false
  constructor(debug: boolean) {
    this.debug = debug
  }

  log(type: string, message: string) {
    // eslint-disable-next-line no-console
    if (this.debug) console.debug(`${type} -> ${message}`)
  }
}
